import { FrameType, TAssistantMessageFrame } from '@/models/chat.model';

import type { TDebugLogEntry } from '@/modules/Socket';

// Pulls the handful of backend diagnostics devs care about most (latency,
// card count, escalation/suppression flags, raw `debug` payload presence)
// into short inline tags, visible in the log without expanding the raw JSON.
export const getEntryTags = (entry: TDebugLogEntry): string[] => {
  if (entry.direction !== 'in' || entry.label !== FrameType.ASSISTANT_MESSAGE) return [];

  const frame = entry.payload as Partial<TAssistantMessageFrame> | undefined;
  if (!frame) return [];

  const tags: string[] = [];

  if (frame.metadata?.latency_ms !== undefined) tags.push(`${frame.metadata.latency_ms}ms`);
  if (frame.cards?.length) tags.push(`${frame.cards.length} card${frame.cards.length > 1 ? 's' : ''}`);
  if (frame.metadata?.escalate) tags.push('escalate');
  if (frame.metadata?.cards_suppressed) tags.push('suppressed');
  if (frame.metadata?.degraded_reason) tags.push(`degraded: ${frame.metadata.degraded_reason}`);
  if (frame.debug && Object.keys(frame.debug).length > 0) tags.push('debug');

  return tags;
};
